<template>
	<div class="main-content">
		<chatItem   
		v-for="chat in chats"
		v-bind:key="chat.cid"
		v-bind:chat="chat"
		@jump-to-chat="$emit('jump-to-chat',chat.cid)"
		/>
	</div>
</template>

<script>
// @ is an alias to /src
import chatItem from "@/components/chatItem.vue"

export default {
	name: 'home',
	components: {
		chatItem
	},
	data: function (){
		return {
			chats:[]
		}
	},
    watch: {
        '$store.state.chats': {
            handler: function(newer, older) { 
                // alert('new');
                this.chats=newer;
            },
            deep: true 
        }
    },
	mounted(){
		this.chats=this.$store.state.chats;
	}
}
</script>

<style>

</style>
